// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__125p7","footer":"ModalCreateQualiphyProcedure_footer__139tP","additionData":"ModalCreateQualiphyProcedure_additionData__jukzz"};